module.exports = __webpack_public_path__ + "img/geo.48f3e071.svg";